import { ISessionEvent, SessionEvent, SessionEventTypes } from '../../event-stack';
import { Client } from '../api-client';
import { getPlayerState } from '../utilities';

const getActivePoll = (entityId: string) => `v2/poll/entity/${entityId}/active-poll`;

const getPollDetails = (pollId: string) => `v2/poll/${pollId}/details`;

const getAllPostPoll = (entityId: string) => `v2/poll/${entityId}/all-poll-details`;

const getUserResults = (pollId: string) => `v2/poll/${pollId}/show-user-result`;

const getPollResult = (pollId: string) => 'v2/' + `poll/${pollId}/result`;

const getSelfResult = (entityId: string) => 'v2' + `/poll/entity/${entityId}/leaderboard/self`;

const getScheduledLeaderBoard = (entityId: string) => 'v2' + `/poll/entity/${entityId}/leaderboard`;

const upvotePoll = () => 'v2/poll/upvote-poll';
export const fetchActivePoll = async ({ queryKey }: { queryKey: any }) => {
  const { scheduleId } = queryKey[1];
  try {
    // @ts-ignore
    const player = window.player;
    const event: ISessionEvent = {
      type: SessionEventTypes.ActivePOLLRequest,
      data: {
        timestamp: new Date().toLocaleString(),
        description: 'API Call for Active Poll',
        videoDuration: player?.currentTime(),
        videoState: getPlayerState(),
        data: {
          scheduleId,
        },
      },
    };
    // Get the element you want to observe.
    // SessionEventrecord(event);
    const res = await Client.get(getActivePoll(scheduleId));
    const eventResponse: ISessionEvent = {
      type: SessionEventTypes.ActivePOLLResponse,
      data: {
        timestamp: new Date().toLocaleString(),
        description: 'API Response for Active Poll',
        videoDuration: player?.currentTime(),
        videoState: getPlayerState(),
        data: {
          scheduleId,
          response: res,
        },
      },
    };
    // Get the element you want to observe.
    // SessionEventrecord(eventResponse);
    return res;
  } catch (e) {
    throw e;
  }
};

export const fetchAllPostPollData = async ({ queryKey }: { queryKey: any }) => {
  const { scheduleId } = queryKey[1];
  try {
    const res = await Client.get(getAllPostPoll(scheduleId));
    return res;
  } catch (e) {
    throw e;
  }
};

export const fetchPollDetails = ({ queryKey }: { queryKey: any }) => {
  const { pollId } = queryKey[1];
  return Client.get(getPollDetails(pollId));
};

export const upvotePollFetcher = (data: any) => {
  return Client.put(upvotePoll(), { ...data });
};

export const fetchPollResult = (pollId: string) => {
  return Client.get(getPollResult(pollId));
};
export const fetchUserPollResult = ({ queryKey }: { queryKey: any }) => {
  const { pollId } = queryKey[1];
  return Client.get(getUserResults(pollId));
};

export const fetchUserPollResultFromApi = (pollId: string) => {
  return Client.get(getUserResults(pollId));
};

export const fetchUserPollStatsFromApi = (entityId: string) => {
  return Client.get(getSelfResult(entityId));
};

export const fetchScheduledLeaderBoardFromApi = (entityId: string) => {
  return Client.get(getScheduledLeaderBoard(entityId));
};
